module.exports = ".svgImg svg {\n  width: 200px;\n  height: 200px;\n}"